module.exports = __webpack_public_path__ + "img/markdown-dark-01.15a4a495.jpg";